var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M18.25 8.82353C18.25 9.53952 17.9718 10.451 17.4567 11.4965C16.9482 12.5284 16.2421 13.625 15.463 14.6929C13.9052 16.828 12.1029 18.7842 11.144 19.7827C11.0615 19.8686 10.9385 19.8686 10.856 19.7827C9.8971 18.7842 8.09477 16.828 6.53703 14.6929C5.75789 13.625 5.05182 12.5284 4.54334 11.4965C4.02816 10.451 3.75 9.53952 3.75 8.82353C3.75 4.93261 6.98008 1.75 11 1.75C15.0199 1.75 18.25 4.93261 18.25 8.82353Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 11,
    cy: 9,
    r: 1,
    stroke: "currentColor",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.bec7e819e621b0568708820ced9ebdb1.svg";